/**
 * Level 8: Neon City
 * 
 * Cyberpunk-themed level with fast-paced action:
 * - Neon color scheme (pink/cyan)
 * - Multiple trampolines for momentum
 * - Portal shortcuts
 * - Fast-moving platforms
 * 
 * @module configs/levels/Level08_NeonCity
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level08_NeonCity = {
    id: 8,
    name: 'Neon City',
    subtitle: 'Electric Dreams',
    description: 'Race through a cyberpunk cityscape with electric hazards.',
    
    worldWidth: 5000,
    worldHeight: 1600,
    playerStart: { x: 100, y: 1400 },
    
    theme: {
        bgGradient: ['#0f0f23', '#1a0a2e'],
        platformColor: 0x2a2a4a,
        accentColor: 0xff00ff,
        particleColor: 0x00ffff,
        ambient: 'neon'
    },
    
    platforms: [
        { x: 0, y: 1500, w: 600, h: 50 },
        { x: 700, y: 1350, w: 200, h: 30 },
        { x: 1000, y: 1200, w: 150, h: 25 },
        { x: 1250, y: 1050, w: 200, h: 30 },
        { x: 800, y: 1500, w: 400, h: 50 },
        { x: 1400, y: 1500, w: 300, h: 50 },
        { x: 1550, y: 900, w: 250, h: 30 },
        { x: 1900, y: 750, w: 200, h: 25 },
        { x: 2200, y: 600, w: 180, h: 25 },
        { x: 2500, y: 800, w: 150, h: 20 },
        { x: 2750, y: 950, w: 150, h: 20 },
        { x: 3000, y: 1100, w: 200, h: 30 },
        { x: 3300, y: 1300, w: 300, h: 50 },
        { x: 3700, y: 1150, w: 200, h: 30 },
        { x: 4000, y: 1000, w: 150, h: 25 },
        { x: 4300, y: 1200, w: 400, h: 50 },
        { x: 4700, y: 1400, w: 300, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 1100, y: 1400, w: 100, h: 20, moveX: 250, speed: 0.008 },
        { x: 2400, y: 700, w: 80, h: 15, moveY: 150, speed: 0.006 },
        { x: 3500, y: 1250, w: 120, h: 20, moveX: 180, speed: 0.007 }
    ],
    
    spikes: [
        { x: 1300, y: 1500 },
        { x: 1350, y: 1500 },
        { x: 2050, y: 750 },
        { x: 3050, y: 1100 },
        { x: 3100, y: 1100 },
        { x: 4400, y: 1200 },
        { x: 4450, y: 1200 }
    ],
    
    stars: [
        { x: 1000, y: 1100 },
        { x: 1550, y: 800 },
        { x: 2200, y: 500 },
        { x: 2750, y: 850 },
        { x: 3700, y: 1050 },
        { x: 4600, y: 1100 },
        { x: 4850, y: 1350 }
    ],
    
    enemies: [
        { x: 900, y: 1450 },
        { x: 1650, y: 850 },
        { x: 3050, y: 1050 },
        { x: 4400, y: 1150 }
    ],
    
    door: { x: 4850, y: 1250, w: 50, h: 300 },
    button: { x: 4500, y: 1195 },
    box: { x: 4050, y: 950, floating: true }, // MAGNETIC BOX
    goal: { x: 4950, y: 1300 },
    
    trampolines: [
        { x: 1500, y: 1500, w: 80 },
        { x: 3200, y: 1300, w: 80 }
    ],
    
    portals: [
        { x1: 600, y1: 1450, x2: 3400, y2: 1250, color: 0xff00ff }
    ],
    
    speedrunTargets: { gold: 55, silver: 75, bronze: 100 }
};

export default Level08_NeonCity;
